import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import Link from 'domain/entity/link';
import EnableLinkCriteria from 'use-case/link/update/updateLinkCriteria';
import { EnableLinkClient } from 'use-case/link/update/updateLinkClient';

const enableLinkApiClient = (httpClient: httpClientFunction, baseUrl: string): EnableLinkClient => (criteria: EnableLinkCriteria) =>
    httpClient(`${baseUrl}/dashboards/dashboards/${criteria.dashboardId}/links/${criteria.id}?location_id=${criteria.locationId}`, {
        method: 'PATCH',
        body: JSON.stringify({ active: criteria.active }),
        headers: { 'Content-Type': 'application/json' },
    })
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then(asLink)
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));

const asLink = (linkJson: LinkJson) => new Link(linkJson.id, linkJson.linked_url, linkJson.active);

export type LinkJson = {
    id: string;
    ['linked_url']: string;
    active: boolean;
};

export default enableLinkApiClient;
